module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_ClayTerrRoof.c71a3e6a.jpg";